import React, { useEffect } from "react";
import { UxLoading } from "@imaginelearning/mps-ux-component-library";
import { getUser, signinCallback } from "../../helpers/auth-service";
import useStudentAuth from "./useStudentAuth";

async function getOidcUser() {
  let user = await getUser();
  if (!user) {
    user = await signinCallback();
  }
  return user;
}

export default function Auth() {
  const { logStudentIn } = useStudentAuth();

  useEffect(() => {
    getOidcUser().then(async (user) => {
      if (user) {
        const { access_token: accessToken, refresh_token: refreshToken } = user;
        // for API access
        await logStudentIn(accessToken, refreshToken);
      }
    });
  }, [logStudentIn]);

  return <UxLoading />;
}
